export interface WorkSlot { day: number; start: number; end: number; next_day: number }
export interface WorkSchedule {
 site_id?: string | null;
 id: string; employment_terms_id: string; effective_from: string; slots: WorkSlot[];
 weekly_minutes: number; voided_at: string | null;
}
export type WorkScheduleClockPolicySource = 'company_policy' | 'employment_agreement' | 'consultant_review';
export interface WorkScheduleClockPolicy {
 id: string; work_schedule_id: string; effective_from: string;
 late_start_tolerance_minutes: number; early_end_tolerance_minutes: number;
 source: WorkScheduleClockPolicySource;
}
/** Configuration values only; they do not alter a signed punch or computed time. */
export function validClockToleranceMinutes(value: number): boolean {
 return Number.isInteger(value) && value >= 0 && value <= 1440;
}
export function slotTime(minutes: number): string {
 return `${Math.floor(minutes/60).toString().padStart(2,'0')}:${(minutes%60).toString().padStart(2,'0')}`;
}
export function weeklyMinutes(slots: WorkSlot[]): number {
 return slots.reduce((sum,slot)=>sum+slot.end+slot.next_day*1440-slot.start,0);
}
export function validWeeklySlots(slots: WorkSlot[]): boolean {
 if (!slots.length || slots.length>28) return false;
 const ranges: Array<[number,number]> = [];
 for (const s of slots) {
  if (![s.day,s.start,s.end,s.next_day].every(Number.isInteger) || s.day<1 || s.day>7 || s.start<0 || s.start>1439
   || s.end<0 || s.end>1439 || s.next_day<0 || s.next_day>1) return false;
  const duration=s.end+s.next_day*1440-s.start;
  if (duration<=0 || duration>1440) return false;
  const a=(s.day-1)*1440+s.start, b=a+duration;
  if (ranges.some(([x,y])=>[-10080,0,10080].some(offset=>a+offset<y && b+offset>x))) return false;
  ranges.push([a,b]);
 }
 return true;
}

/** Past versions use their original reference date; only the current pattern needs reconfirmation against today's terms. */
export function scheduleReferenceDate(row: WorkSchedule, all: WorkSchedule[], today: string): string {
 return row.effective_from>today || all.some(other=>!other.voided_at&&other.effective_from>row.effective_from&&other.effective_from<=today)
  ? row.effective_from : today;
}
